import { useEffect } from 'react';
import { useMatch, Outlet, useNavigate, NavLink } from 'react-router-dom';
import {
  PermissionEnum,
  PermissionDenied,
  IconLoader,
  IconExpand,
  Tabs,
} from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import ROUTES from '../../routes';
import { clearLocksState } from './store/slices/locks';
import { clearLogsState } from './store/slices/logs';

import cn from './styles.module.css';

const Security = (): React.JSX.Element => {
  const navigate = useNavigate();

  const match = useMatch(ROUTES.SECURITY);
  const pageMatch = useMatch(ROUTES.SECURITY_LOCKS);

  const dispatch = useAppDispatch();

  const { activePermissions } = useAppSelector(
    (state) => state.administrationDictionaries,
  );

  useEffect(() => {
    if (match && activePermissions?.includes(PermissionEnum.LOCKS_LIST)) {
      navigate(ROUTES.SECURITY_LOCKS);
    } else if (
      match &&
      !activePermissions?.includes(PermissionEnum.LOCKS_LIST) &&
      activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST)
    ) {
      navigate(ROUTES.SECURITY_LOGS);
    }
  }, [match, activePermissions]);

  useEffect(() => {
    let title = 'Administration';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  useEffect(
    () => () => {
      dispatch(clearLocksState());
      dispatch(clearLogsState());
    },
    [],
  );

  let content = (
    <div className={cn.securityLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.LOCKS_LIST) &&
      !activePermissions.includes(PermissionEnum.AUDIT_LOG_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.securityContent}>
          <div className={cn.securityContentTop}>
            <div className={cn.securityContentTitle}>
              <div className={cn.securityContentTitleText}>Security</div>
              {activePermissions?.includes(
                PermissionEnum.LOCKS_CREATE_ACTION,
              ) && (
                <NavLink
                  to={
                    pageMatch
                      ? ROUTES.SECURITY_LOCKS_CREATE
                      : ROUTES.SECURITY_LOGS_CREATE
                  }
                  className={cn.securityCreateLink}
                >
                  <div className={cn.iconWrapper}>
                    <IconExpand />
                  </div>
                  <div className={cn.textWrapper}>Block a user</div>
                </NavLink>
              )}
            </div>

            <div className={cn.securityTabsWrapper}>
              {activePermissions?.includes(PermissionEnum.LOCKS_LIST) &&
                activePermissions.includes(PermissionEnum.AUDIT_LOG_LIST) && (
                  <Tabs
                    itemClassName={cn.securityTabItem}
                    wrapperClassName={cn.securityTabs}
                    tabs={[
                      {
                        name: 'Locks',
                        path: ROUTES.SECURITY_LOCKS,
                      },
                      {
                        name: 'Audit Logs',
                        path: ROUTES.SECURITY_LOGS,
                      },
                    ]}
                    enableRouting
                  />
                )}
            </div>
          </div>
          <div className={cn.securityContentBottom}>
            <Outlet />
          </div>
        </div>
      );
    }
  }

  return <div className={cn.securityContentWrapper}>{content}</div>;
};

export default Security;
